<template>
  <div class="panel border-right border-left">
    <div class="loading-prepare" v-if="isLoading">
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else class="card-chat mb-sm-3 mb-md-0 contacts_card-chat">
      <div v-if="!isError" class="card-chat-body contacts_body">
        <div
          v-for="(item, i) in conversation.chatList"
          :key="i"
          :class="[
            'contacts py-2',
            item.userId === currentSelectChatId ? 'active' : '',
          ]"
          @click="$emit('select-chat', item.userId)"
        >
          <li class="">
            <div class="d-flex bd-highlight">
              <div class="img_cont">
                <div
                  v-if="item.userImageUrl && item.userImageUrl.trim() != ''"
                  class="rounded-circle user_img"
                >
                  <div
                    class="rounded-circle user_img_display"
                    v-bind:style="{
                      backgroundImage: 'url(' + item.userImageUrl + ')',
                    }"
                  ></div>
                </div>
                <font-awesome-icon
                  v-else
                  :icon="['fas', 'user']"
                  class="rounded-circle user_img p-1"
                />
              </div>
              <div class="user_info">
                <span>{{
                  !item.name || item.name.trim().length == 0
                    ? "user" + item.userId.split("getfin")[1]
                    : item.name
                }} test</span>
                <p
                  v-if="item.detailLastMessage"
                  :class="[
                    'mb-0',
                    item.detailLastMessage.senderId != meProfile.chatId &&
                    (!item.detailLastMessage.readBy ||
                      !item.detailLastMessage.readBy.length ||
                      !item.detailLastMessage.readBy.includes(item.adminUserId))
                      ? 'unread-conversation'
                      : '',
                  ]"
                >
                  {{
                    item.detailLastMessage.isMessage === false
                      ? `${
                          item.detailLastMessage.senderId === meProfile.chatId
                            ? $t("you") + ": "
                            : ""
                        }${$t("sendPhoto")}`
                      : `${
                          item.detailLastMessage.senderId === meProfile.chatId
                            ? $t("you") + ": "
                            : ""
                        }${item.detailLastMessage.message}`
                  }}
                </p>
              </div>
              <div
                v-if="item.detailLastMessage"
                class="update-time-inbox ml-auto"
              >
                <div
                  v-if="
                    item.detailLastMessage.senderId != meProfile.chatId &&
                      (!item.detailLastMessage.readBy ||
                        !item.detailLastMessage.readBy.length ||
                        !item.detailLastMessage.readBy.includes(
                          item.adminUserId
                        ))
                  "
                  class="ml-auto unread-message font-weight-bold"
                >
                  {{ $t("new") }}
                </div>
                <ChatDateTime :date="item.detailLastMessage.chatDateTime" />
              </div>
            </div>
          </li>
        </div>
      </div>
      <div v-else class="reload-chat">
        <div class="text-center">
          <p>Network error!!</p>
          <button class="btn btn-primary btn-sm" @click="prepareData">
            Reload
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatDateTime from "@/components/chat/ChatDateTime";
export default {
  name: "ChatList",
  components: {
    ChatDateTime,
  },
  props: {
    meProfile: {
      required: true,
      type: Object,
    },
    currentSelectChatId: {
      required: false,
      type: String,
    },
  },
  data() {
    return {
      isError: false,
      isLoading: false,
      chatList: {},
      lastConversationId: "",
      conversation: {
        chatList: [],
        total: 0,
      },
    };
  },
  methods: {
    prepareData() {
      this.isError = false;
      this.isLoading = true;
      this.$emit("set-show-title", true);
      this.getChatList();
    },
    getChatList() {
      let body = {
        search: "",
        limit: 100,
        startingAfter: "",
      };
      fetch(`${this.$chatBaseUrl}/talkjs/list`, {
        method: "POST",
        headers: new Headers(this.$headersChat),
        body: JSON.stringify(body),
      })
        .then(response => response.json())
        .then(async result => {
          this.isLoading = false;
          if (result.result) {
            if (this.conversation.chatList.length) {
              let tempResultData = result.detail.chatList;
              let tempConData = JSON.parse(
                JSON.stringify(this.conversation.chatList)
              );
              let idxCon = tempConData.findIndex(
                itm =>
                  itm.conversationId ===
                  tempResultData[tempResultData.length - 1].conversationId
              );
              tempConData.splice(0, idxCon + 1);
              let newDataCon = tempResultData.concat(tempConData);
              newDataCon.forEach((ele, i) => {
                if (!ele.detailLastMessage) {
                  const tempLastMess = this.conversation.chatList.find(
                    (temp, k) =>
                      ele.conversationId === temp.conversationId && i === k
                  );
                  if (tempLastMess) {
                    newDataCon[i].detailLastMessage =
                      tempLastMess.detailLastMessage;
                  }
                }
                if (i + 1 >= newDataCon.length) {
                  this.conversation.chatList = newDataCon;
                  this.conversation.chatList.forEach(async (ele, j) => {
                    if (!ele.detailLastMessage) {
                      this.getChatDetail(ele.conversationId);
                    } else if (j === 0) {
                      this.getChatDetail(ele.conversationId);
                    }
                  });
                }
              });
            } else {
              this.conversation = result.detail;
              await result.detail.chatList.forEach(async ele => {
                if (!ele.detailLastMessage) {
                  this.getChatDetail(ele.conversationId);
                }
              });
              if (!this.conversation.chatList.length) {
                this.$emit("handle-no-list-chat", true);
              }
            }
            this.conversation.chatList = this.conversation.chatList.filter(
              (value, index, self) =>
                index ===
                self.findIndex(t => t.conversationId === value.conversationId)
            );
          } else {
            this.isError = true;
          }
        })
        .catch(error => {
          console.log("error", error);
          this.isError = true;
          this.isLoading = false;
        });
    },
    getChatDetail(conversationId) {
      fetch(`${this.$chatBaseUrl}/talkjs/${conversationId}/detail`, {
        method: "GET",
        headers: new Headers(this.$headersChat),
      })
        .then(response => response.json())
        .then(async result => {
          if (result.result == 1) {
            this.conversation.chatList.forEach((item, i) => {
              if (conversationId === item.conversationId) {
                this.$set(this.conversation.chatList, i, {
                  ...this.conversation.chatList[i],
                  detailLastMessage: result.detail,
                });
              }
            });
          }
        })
        .catch(error => {
          console.log("error", error);
          this.isError = true;
          this.isLoading = false;
        });
    },
    setListNewCon(conversationId) {
      const idx = this.conversation.chatList.findIndex(
        item => item.conversationId === conversationId
      );
      if (idx > 0) {
        const tempCon = this.conversation.chatList[idx];
        this.conversation.chatList.splice(idx, 1);
        this.conversation.chatList = [tempCon, ...this.conversation.chatList];
      }
      this.getChatDetail(conversationId);
    },
    handleReadChat(conId) {
      this.conversation.chatList.map(itm =>
        conId === itm.conversationId
          ? (itm.detailLastMessage.readBy = [
              ...itm.detailLastMessage.readBy,
              itm.adminUserId,
            ])
          : itm
      );
    },
  },
  created() {
    this.prepareData();
  },
  watch: {
    "$store.state.isLoadChatConversationList": function() {
      if (this.$store.state.isLoadChatConversationList) {
        this.getChatList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.panel {
  height: 100%;
  margin: 0;
}
.card-chat {
  height: 100%;
  background-color: #fff;
  border-radius: 0;
}
.contacts_body {
  height: 100%;
  padding: 0 !important;
  overflow-y: auto;
  white-space: nowrap;
}
.contacts_body::-webkit-scrollbar {
  width: 0.35em;
}
.contacts_body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(177, 175, 175, 0.3);
}
.contacts_body::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  outline: 1px solid #c1c1c1;
}
.card-chat-header {
  border-radius: 15px 15px 0 0 !important;
  border-bottom: 0 !important;
}
.card-chat-footer {
  border-radius: 0 0 15px 15px !important;
  border-top: 0 !important;
}
.search {
  border-radius: 15px 0 0 15px !important;
  background-color: rgba(0, 0, 0, 0.3) !important;
  border: 0 !important;
  color: white !important;
}
.search:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
.search_btn {
  border-radius: 0 15px 15px 0 !important;
  background-color: rgba(0, 0, 0, 0.3) !important;
  border: 0 !important;
  color: white !important;
  cursor: pointer;
}
.contacts {
  list-style: none;
  padding: 0;
  cursor: pointer;
  border-bottom: 1px solid #e4e4e4;
  background-color: #ffffffbb;
}
.contacts li {
  width: 100% !important;
  padding: 5px 10px;
  // margin-top: 10px !important;
  // margin-bottom: 10px !important;
}
.active {
  background-color: rgba(175, 175, 175, 0.2);
}
.user_img {
  height: 36px;
  width: 36px;
  border: 1.5px solid #f5f6fa;
}
.user_img_display {
  width: 100%;
  padding-bottom: 100.5%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #fff;
}
.img_cont {
  position: relative;
  height: 36px;
  width: 36px;
}
.online_icon {
  position: absolute;
  height: 15px;
  width: 15px;
  background-color: #4cd137;
  border-radius: 50%;
  bottom: 0.2em;
  right: 0.4em;
  border: 1.5px solid white;
}
.offline {
  background-color: #c23616 !important;
}
.user_info {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 15px;
}
.user_info span {
  font-size: 18px;
  color: rgb(0, 0, 0);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.user_info p {
  font-size: 16px;
  color: #9c9c9c;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.unread-conversation {
  color: #000 !important;
  font-size: 18px !important;
}
.update-time-inbox {
  position: relative;
  font-size: 17px;
  width: auto;
  color: #9c9c9c;
  margin: auto 0;
}
.update-time-inbox .unread-message {
  color: #ef4453;
  border-radius: 50% !important;
  height: 10px;
  margin-bottom: 8px;
  text-align: right;
}

.reload-chat,
.loading-prepare {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

@media (max-width: 767.98px) {
  .card-chat {
    height: calc(100% - 104px);
    background-color: #fff;
    border-radius: 0;
    /* overflow: hidden; */
    /* overflow-y: auto; */
    position: fixed;
    width: 100%;
    top: 104px;
    left: 0;
  }
  .contacts_body {
    position: relative;
    // height: calc(100% - 104px - 50px);
    width: 100%;
    top: 0;
    left: 0;
  }
}
</style>
